import components from './components'
import extensions from './extensions'

const data = [...components, ...extensions]

export default data
